import { Badge } from '@mantine/core';
import { ContractStatus } from '../../../api/contracts';

interface ContractStatusBadgeProps {
  status: ContractStatus;
}

export function ContractStatusBadge({ status }: ContractStatusBadgeProps) {
  const colorMap = {
    NOT_STARTED: 'blue',
    DRAFT: 'gray',
    ACTIVE: 'green',
    EXPIRED: 'red',
    TERMINATED: 'orange',
  };

  return (
    <Badge color={colorMap[status]} variant="light">
      {status}
    </Badge>
  );
}

